import React, { useState, useEffect } from "react";
import { Sobre } from "./components/sobre";
import { Footer } from "./components/footer";
import { Leads } from "./components/leads";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      {/* ATISE PAGES */}
      <Leads   data={landingPageData.Leads} />
      <Sobre   data={landingPageData.Sobre}   />
      <Footer  data={landingPageData.Footer}  />
      
    </div>
  );
};

export default App;
